import {baseRequestService} from "../base.ts";
import {EventComment} from "../../types/domain.ts";

export const eventsEventIdCommentsGet = (eventId: string) => baseRequestService<EventComment[]>({
    url: `/events/${eventId}/comments`,
    method: 'GET'
})